import { useEffect, useState } from 'react';

const useRecaptchaValidation = (siteKey: string) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const loadRecaptcha = () => {
      if (window.grecaptcha?.enterprise) {
        window.grecaptcha.enterprise.ready(() => {
          setIsReady(true);
        });
      }
    };

    if (window.grecaptcha?.enterprise) {
      loadRecaptcha();
    } else {
      const scriptId = 'recaptcha-enterprise';
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
        script.async = true;
        script.onload = loadRecaptcha;
        document.head.appendChild(script);
      }
    }
  }, [siteKey]);

  const getToken = async (action: string): Promise<string | null> => {
    if (!isReady || !window.grecaptcha?.enterprise) return null;
    try {
      const token = await window.grecaptcha.enterprise.execute(siteKey, { action });
      return token;
    } catch (err) {
      console.error('reCAPTCHA error:', err);
      return null;
    }
  };

  return { getToken, isReady };
};

export default useRecaptchaValidation;
